export const wordWrapStyling = (isSmallScreen: boolean) =>
	isSmallScreen
		? {
				display: 'flex',
				flexDirection: 'column',

				textAlign: 'center',
				justifyContent: 'center',
		  }
		: {};
